<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="88" height="56" viewBox="0 0 88 56" fill="none" aria-hidden="true">
        <g style="mix-blend-mode: darken">
            <circle cx="28" cy="28" r="28" fill="#E84C8E"></circle>
            <circle cx="60" cy="28" r="28" fill="#81DADA"></circle>
        </g>
        <path d="M44 5.02C51.25 10.08 56 18.48 56 28C56 37.51 51.25 45.92 44 50.98C36.75 45.92 32 37.51 32 28C32 18.48 36.75 10.08 44 5.02Z" fill="#FBB877"></path>
    </svg>
</template>
